<template>
  <div class='about-us-section-wrapper'>
      <div class="container">
          <h2 class='about-us-title h2-title'>
              <span>Чому ми?</span>
          </h2>
          <div class='about-us-text paragraph-s'>
            Основним напрямом діяльності нашої компанії є пошиття медичного одягу, робочого одягу та форми для працівників сфери обслуговування.
            Ми працюємо на ринку понад 20 років, і за цей час нашими клієнтами стали численні лікарні, аптеки, салони краси та санаторії.
          </div>
        <div class='about-us-wrapper'>
            <div class="about-us-items-row">
                 <div class="about-us-item">
                    <div class="about-us-item-icon">
                        <v-icon name='thumbs-up' scale='4'></v-icon>
                    </div>
                    <h4 class='h4-title about-us-item-title'>Відмінна якість</h4>
                </div>
                <div class="about-us-item">
                    <div class="about-us-item-icon">
                        <v-icon name='tags' scale='5'></v-icon>
                    </div>
                     <h4 class='h4-title about-us-item-title'>Великий вибір тканин</h4>
                </div>
            </div>
            <div class="about-us-items-row">
                <div class="about-us-item">
                    <div class="about-us-item-icon">
                        <v-icon name='restroom' scale='5'></v-icon>
                    </div>
                    <h4 class='h4-title about-us-item-title'>Різноманіття моделей</h4>
                </div>
                <div class="about-us-item">
                    <div class="about-us-item-icon">
                        <v-icon name='user-md' scale='4'></v-icon>
                    </div>
                    <h4 class='h4-title about-us-item-title'>Індивідуальний підхід</h4>
                </div>
            </div>
        </div>
      </div>
  </div>
</template>

<script>
export default {
  name: 'AboutUsSection'
}
</script>

<style lang="scss" scoped>
@import 'src/styles/_colors.scss';
@import 'src/styles/_sizes.scss';

.about-us-section-wrapper {
    background: $white-color;
    padding: 100px 0px;
    border-bottom: 1px solid $border-color;
    & .about-us-title {
        margin-bottom: 20px;
    }
    & .about-us-text {
        margin-bottom: 45px;
    }
    & .about-us-wrapper {
        display: flex;
        flex-wrap: wrap;
        & .about-us-items-row {
            display: flex;
            flex-grow: 1;
            & .about-us-item {
                display: flex;
                flex-grow: 1;
                align-items: center;
                flex-direction: column;
                & .about-us-item-icon {
                    color: $primary-color;
                    height: 65px;
                    display: flex;
                    align-items: center;
                    justify-content: center;
                    margin-bottom: 25px;
                }
                & .about-us-item-title {
                    padding-bottom: 5px;
                    border-bottom: 1px solid $primary-color;
                }
            }
            &:first-child {
                & .about-us-item {
                    margin-right: 30px;
                }
            }
            &:last-child {
                 & .about-us-item:first-child {
                    margin-right: 30px;
                }
            }
        }
    }
}

@media (max-width: $desktop){
    .about-us-section-wrapper {
        & .about-us-wrapper {
            flex-direction: column;
            & .about-us-items-row {
                margin-bottom: 30px;
                &:first-child {
                    & .about-us-item {
                        margin-right: 0px;
                    }
                }
                &:last-child {
                    & .about-us-item:first-child {
                        margin-right: 0px;
                    }
                }
            }
        }
    }
}
@media (max-width: $tablet){
    .about-us-section-wrapper {
        padding: 50px 0px;
    }
}
@media (max-width: $mobile){
    .about-us-section-wrapper {
        & .about-us-title {
            margin-bottom: 15px;
        }
        & .about-us-text {
            margin-bottom: 30px;
        }
        & .about-us-wrapper {
            & .about-us-items-row {
                flex-direction: column;
                margin-bottom: 0;
                & .about-us-item {
                    margin-bottom: 30px;
                }
            }
        }
    }
}
</style>
